// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__pmk6R","userInfo":"Settings_userInfo__z+U69","formGroup":"Settings_formGroup__NZmw+"};